import React from "react";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import Grid from "@material-ui/core/Grid";

export default function FormDialog(props) {
  //   const [open, setOpen] = React.useState(props.open);
  const [remark, setRemark] = React.useState("ชื่อผิด");
  const bill = props.cancel_id;
  const handleClose = () => {
    props.onCloseDialog();
  };
  const changeRemark = (e) => {
    setRemark(e.target.value);
  };

  const confirmCancel = () => {
    var txt = remark;
    if (remark === "other") {
      txt = document.getElementById("otherRemark").value;
      if (!txt || txt.trim() === "") {
        txt = "อื่น ๆ";
      }
    }
    props.confirmCancel(txt);
  };

  return (
    <div>
      <Dialog
        open={props.open}
        // onClose={handleClose}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">
          <div style={{ fontWeight: 400 }}>เหตุผลการยกเลิกใบเสร็จ</div>
        </DialogTitle>
        <DialogContent style={{ minWidth: "300px" }}>
          {bill && (
            <div>
              <div>
                ยกเลิกใบเสร็จเลขที่{" "}
                <span style={{ color: "#f00" }}>{bill.bill_id}</span>
              </div>
              {bill.operator && bill.operator.usn && (
                <div>
                  ออกโดย :{" "}
                  <span style={{ color: "#f00" }}>{bill.operator.usn}</span>
                </div>
              )}
            </div>
          )}

          <FormControl component="fieldset">
            <RadioGroup value={remark} onChange={changeRemark}>
              <FormControlLabel
                value="ชื่อผิด"
                control={<Radio />}
                label="ชื่อผิด"
              />
              <FormControlLabel
                value="จำนวนเงินผิด"
                control={<Radio />}
                label="จำนวนเงินผิด"
              />
              <FormControlLabel
                value="ประเภทรายได้ผิด"
                control={<Radio />}
                label="ประเภทรายได้ผิด"
              />
              <FormControlLabel
                value="เปลี่ยนใจไม่ชำระเงิน"
                control={<Radio />}
                label="เปลี่ยนใจไม่ชำระเงิน"
              />
              <Grid container>
                <Grid item>
                  <FormControlLabel
                    value="other"
                    control={<Radio />}
                    label="อื่นๆ"
                  />
                </Grid>
                <Grid item>
                  <TextField
                    autoFocus
                    margin="dense"
                    id="otherRemark"
                    type="text"
                    fullWidth
                  />
                </Grid>
              </Grid>
            </RadioGroup>
          </FormControl>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Cancel
          </Button>
          <Button onClick={confirmCancel} color="primary">
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
